import { render, staticRenderFns } from "./IconSvgPauseCircle.vue?vue&type=template&id=45d4c315&scoped=true&"
import script from "./IconSvgPauseCircle.vue?vue&type=script&lang=js&"
export * from "./IconSvgPauseCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4c315",
  null
  
)

export default component.exports